"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GetObjectInput_1 = require("./GetObjectInput");
var GetObjectOutput_1 = require("./GetObjectOutput");
var NoSuchKey_1 = require("./NoSuchKey");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.GetObject = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "GetObject",
    http: {
        method: "GET",
        requestUri: "/{Bucket}/{Key+}"
    },
    input: {
        shape: GetObjectInput_1.GetObjectInput
    },
    output: {
        shape: GetObjectOutput_1.GetObjectOutput
    },
    errors: [
        {
            shape: NoSuchKey_1.NoSuchKey
        }
    ]
};
//# sourceMappingURL=GetObject.js.map